export default "__VITE_ASSET__OR60gVS3__"